import PetriElementFactory from "./pertiElementFactory";

export default {
    __init__ : [
        'elementFactory'
    ],
    elementFactory: ['type', PetriElementFactory]
}